/**
 * Polymarket S3 images (team crests, profile avatars, post media).
 *
 * 2026-07-03: PM killed hotlinking through their image optimizer
 * (`polymarket.com/_next/image` now resets the connection), which broke
 * every PM S3 image site-wide. The raw S3 bucket is now publicly readable
 * (200 — the old "403 IP-restricted" assumption is stale), so we serve the
 * raw URL DIRECTLY. The browser loads it straight from S3 → images work AND
 * it costs ZERO origin/Railway egress (bytes never transit our server).
 *
 * Used by raw `<img>` tags in MarketTalks (avatars, post media). `_width` is
 * kept for call-site compatibility; S3 crests/avatars are small enough to
 * serve unresized.
 */
export function rewritePmImage(
  url: string | null | undefined,
  _width: "thumbnail" | "hero" = "thumbnail",
): string {
  if (!url) return "";
  return url;
}
